import React from 'react'
import clpLogo from "../../../assets/clp-logo.png";
import "./footer.css"

import facebook from "../../../assets/facebook.png"
import instagram from "../../../assets/instagram.png"
import youtube from "../../../assets/youtube.png"
import linkedIn from "../../../assets/linkedIn.png"
import twitter from "../../../assets/twitter.png"

const Footer = () => {
  return (
    <div className='footerContainer'>

            <img src={clpLogo} className="footerClpLogo"/>

            <div className="socialContainer">
                <img src={facebook}  className='facebook' onClick={()=>{window.open('https://www.facebook.com/classplusapp/','_blank')}}/>
                <img src={instagram} className='instagram' onClick={()=>{window.open('https://instagram.com/classplusculture?utm_medium=copy_link', "_blank")}}/>
                <img src={youtube} className='youtube' onClick={()=>{window.open('https://www.youtube.com/channel/UCp0yDDnyu-C-0Bo_y1JbGtA','_blank')}} />
                <img src={linkedIn} className='linkedin' onClick={()=>{window.open('https://www.linkedin.com/company/classplus', '_blank')}} />
                <img src={twitter} className='twitter' onClick={()=>{window.open('https://twitter.com/classplusapps?lang=en', '_blank')}}/>
               

            </div>
    </div>
  )
}

export default Footer